import { render, staticRenderFns } from "./OrderCompletionScanLabel.vue?vue&type=template&id=f3e713d8&scoped=true&"
import script from "./OrderCompletionScanLabel.vue?vue&type=script&lang=js&"
export * from "./OrderCompletionScanLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e713d8",
  null
  
)

export default component.exports